import React from "react";
import { Icon } from "../../../atoms/Icon";
import FormHeading from "../../../atoms/FormHeading/FormHeading";
import styles from "./BillingInformationSettings.module.scss";

export function BillingCardInfo({ paymentMethod, setIsPaymentSidebarOpen }) {
  const { type, last4 } = paymentMethod;

  return (
    <>
      <div className={styles.row}>
        <div className={styles.headingHolder}>
          <FormHeading className={styles.heading} weight="600">
            Payment Method
          </FormHeading>
        </div>
      </div>

      <div className={styles.cCardInfo}>
        <div className={styles.col_1}>
          <div className={styles.iconHolder}>
            <Icon
              name="credit-card"
              size={20}
              className={styles.icon}
              color="#8a9ba8"
            />
          </div>
        </div>

        <div className={styles.col_2}>
          <h3 className={styles.heading}>{type} Card Ending in</h3>
          <div className={styles.ccDigits}>
            <div className={styles.numberSet}>●●●● ●●●● ●●●●</div>
            <div className={styles.numberSet}>{last4}</div>
          </div>
        </div>

        <div className={styles.col_3}>
          <button
            className={styles.buttonEdit}
            onClick={() => {
              setIsPaymentSidebarOpen(true);
            }}
          >
            <Icon name="edit" size={20} />
            Edit
          </button>
        </div>
      </div>
    </>
  );
}
